import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-mint-creme m-0 text-center timesheets-main-container h-100" }
const _hoisted_2 = { class: "timesheets-header-container" }
const _hoisted_3 = { class: "timesheets-header-box text-white" }
const _hoisted_4 = { class: "timesheet-items-container" }
const _hoisted_5 = { slot: "progress" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "truncate-three-line" }
const _hoisted_8 = { class: "text-right m-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-right m-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.headerText), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_card, {
        loading: _ctx.loading,
        disabled: _ctx.loading,
        class: "h-100 background-none elevation-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("template", _hoisted_5, [
            _createVNode(_component_v_progress_linear, {
              color: "green",
              height: "5",
              indeterminate: ""
            })
          ]),
          _createVNode(_component_v_card_text, { class: "pt-0" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupByCommitment, (commitment, index) => {
                return (_openBlock(), _createBlock(_component_v_row, {
                  key: index,
                  class: "mt-0 pa-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "12",
                      sm: "12",
                      cols: "12",
                      class: "timesheet-item ma-0 mt-5 pa-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "mt-0 pa-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "9",
                              xs: "7",
                              cols: "10"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(commitment[0].Commitment.Name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              md: "3",
                              xs: "5",
                              cols: "2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getCommimentHours(commitment)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commitmentTimesheets(commitment[0].Commitment.id), (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        md: "12",
                        sm: "12",
                        cols: "12",
                        key: index,
                        class: "pa-0 pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            md: "12",
                            onClick: ($event: any) => (_ctx.showTimesheet(item)),
                            sm: "12",
                            cols: "12",
                            class: "timesheet-item clickable ma-0",
                            style: _normalizeStyle(_ctx.backgroundColor(commitment[0].Commitment.id))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, [
                                _createElementVNode("b", null, _toDisplayString(item.IssueNo), 1)
                              ]),
                              _createElementVNode("p", _hoisted_7, _toDisplayString(item.Description), 1),
                              _createElementVNode("p", _hoisted_8, [
                                _createElementVNode("b", null, _toDisplayString(item.Effort) + "H", 1)
                              ]),
                              (item.Adjustment)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                    _createElementVNode("b", null, _toDisplayString(item.Adjustment > 0 ? `+` : ``) + _toDisplayString(item.Adjustment) + "H", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "style"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}